/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as AcceptTosRouteImport } from './routes/accept-tos'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AuthIndexRouteImport } from './routes/_auth/index'
import { Route as AuthSupportRouteImport } from './routes/_auth/support'
import { Route as AuthBillingRouteImport } from './routes/_auth/billing'
import { Route as AuthSupportIndexRouteImport } from './routes/_auth/support.index'
import { Route as AuthSupportTicketIdRouteImport } from './routes/_auth/support.$ticketId'
import { Route as AuthVVideoIdIndexRouteImport } from './routes/_auth/v.$videoId/index'

const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AcceptTosRoute = AcceptTosRouteImport.update({
  id: '/accept-tos',
  path: '/accept-tos',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSupportRoute = AuthSupportRouteImport.update({
  id: '/support',
  path: '/support',
  getParentRoute: () => AuthRoute,
} as any)
const AuthBillingRoute = AuthBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSupportIndexRoute = AuthSupportIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthSupportRoute,
} as any)
const AuthSupportTicketIdRoute = AuthSupportTicketIdRouteImport.update({
  id: '/$ticketId',
  path: '/$ticketId',
  getParentRoute: () => AuthSupportRoute,
} as any)
const AuthVVideoIdIndexRoute = AuthVVideoIdIndexRouteImport.update({
  id: '/v/$videoId/',
  path: '/v/$videoId/',
  getParentRoute: () => AuthRoute,
} as any)

export interface FileRoutesByFullPath {
  '/accept-tos': typeof AcceptTosRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/billing': typeof AuthBillingRoute
  '/support': typeof AuthSupportRouteWithChildren
  '/': typeof AuthIndexRoute
  '/support/$ticketId': typeof AuthSupportTicketIdRoute
  '/support/': typeof AuthSupportIndexRoute
  '/v/$videoId': typeof AuthVVideoIdIndexRoute
}
export interface FileRoutesByTo {
  '/accept-tos': typeof AcceptTosRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/billing': typeof AuthBillingRoute
  '/': typeof AuthIndexRoute
  '/support/$ticketId': typeof AuthSupportTicketIdRoute
  '/support': typeof AuthSupportIndexRoute
  '/v/$videoId': typeof AuthVVideoIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/accept-tos': typeof AcceptTosRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/reset-password': typeof ResetPasswordRoute
  '/_auth/billing': typeof AuthBillingRoute
  '/_auth/support': typeof AuthSupportRouteWithChildren
  '/_auth/': typeof AuthIndexRoute
  '/_auth/support/$ticketId': typeof AuthSupportTicketIdRoute
  '/_auth/support/': typeof AuthSupportIndexRoute
  '/_auth/v/$videoId/': typeof AuthVVideoIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/accept-tos'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/billing'
    | '/support'
    | '/'
    | '/support/$ticketId'
    | '/support/'
    | '/v/$videoId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/accept-tos'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/billing'
    | '/'
    | '/support/$ticketId'
    | '/support'
    | '/v/$videoId'
  id:
    | '__root__'
    | '/_auth'
    | '/accept-tos'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/_auth/billing'
    | '/_auth/support'
    | '/_auth/'
    | '/_auth/support/$ticketId'
    | '/_auth/support/'
    | '/_auth/v/$videoId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  AcceptTosRoute: typeof AcceptTosRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/accept-tos': {
      id: '/accept-tos'
      path: '/accept-tos'
      fullPath: '/accept-tos'
      preLoaderRoute: typeof AcceptTosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/': {
      id: '/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/support': {
      id: '/_auth/support'
      path: '/support'
      fullPath: '/support'
      preLoaderRoute: typeof AuthSupportRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/billing': {
      id: '/_auth/billing'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof AuthBillingRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/support/': {
      id: '/_auth/support/'
      path: '/'
      fullPath: '/support/'
      preLoaderRoute: typeof AuthSupportIndexRouteImport
      parentRoute: typeof AuthSupportRoute
    }
    '/_auth/support/$ticketId': {
      id: '/_auth/support/$ticketId'
      path: '/$ticketId'
      fullPath: '/support/$ticketId'
      preLoaderRoute: typeof AuthSupportTicketIdRouteImport
      parentRoute: typeof AuthSupportRoute
    }
    '/_auth/v/$videoId/': {
      id: '/_auth/v/$videoId/'
      path: '/v/$videoId'
      fullPath: '/v/$videoId'
      preLoaderRoute: typeof AuthVVideoIdIndexRouteImport
      parentRoute: typeof AuthRoute
    }
  }
}

interface AuthSupportRouteChildren {
  AuthSupportTicketIdRoute: typeof AuthSupportTicketIdRoute
  AuthSupportIndexRoute: typeof AuthSupportIndexRoute
}

const AuthSupportRouteChildren: AuthSupportRouteChildren = {
  AuthSupportTicketIdRoute: AuthSupportTicketIdRoute,
  AuthSupportIndexRoute: AuthSupportIndexRoute,
}

const AuthSupportRouteWithChildren = AuthSupportRoute._addFileChildren(
  AuthSupportRouteChildren,
)

interface AuthRouteChildren {
  AuthBillingRoute: typeof AuthBillingRoute
  AuthSupportRoute: typeof AuthSupportRouteWithChildren
  AuthIndexRoute: typeof AuthIndexRoute
  AuthVVideoIdIndexRoute: typeof AuthVVideoIdIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthBillingRoute: AuthBillingRoute,
  AuthSupportRoute: AuthSupportRouteWithChildren,
  AuthIndexRoute: AuthIndexRoute,
  AuthVVideoIdIndexRoute: AuthVVideoIdIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  AcceptTosRoute: AcceptTosRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
